/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { User } from '../../core/_models'
import { formatDateTime } from '../../../../../utils/dayJs/format'

type Props = {

    user: User
}

const CreatedInCell: FC<Props> = ({ user }) => (

    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {user.createdAt ? formatDateTime(user.createdAt.toString()) : 'N/A'}
        </a>
    </div>
)

export { CreatedInCell }
